window.addEventListener("load", (event) => {
  
  // video playbtn
  const videoBtns = document.querySelectorAll(
    ".media_with_icon_cards_section .video_content .play_button"
  );

  videoBtns.forEach((btn) => {
    let id = btn.getAttribute("data-target");
    let video = document.querySelector(
      `.media_with_icon_cards_section .video_content video[data-video='${id}']`
    );
    let btnPlay = btn.querySelector(".play");
    let btnPause = btn.querySelector(".pause");
    let state = 0;

    btn.addEventListener("click", (event) => {
      if (state == 0) {
        video.play();
        state = 1;
        btn.classList.add("playing");
        btnPlay.style.display = "none";
        btnPause.style.display = "block";
      } else {
        video.pause();
        state = 0;
        btn.classList.remove("playing");
        btnPlay.style.display = "Block";
        btnPause.style.display = "none";
      }
    });
  });

  // const medias = document.querySelectorAll(
  //   ".media_with_icon_cards_section .media_content"
  // );

  // const mediaStates = new Map();
  // medias.forEach((media) => mediaStates.set(media, false));

  // if (window.innerWidth < 768) {
  //   window.addEventListener("scroll", (event) => {
  //     medias.forEach((media) => {
  //       const mediaTop = media.getBoundingClientRect().top;
  //       const mediaBottom = media.getBoundingClientRect().bottom;
  //       const video = media.querySelector("video");

  //       const isInViewport = mediaTop < window.innerHeight && mediaBottom > 0;
  //       const wasInViewport = mediaStates.get(media);

  //       if (isInViewport && !wasInViewport) {
  //         video.muted = true;
  //         video.play().then(() => {
  //           setTimeout(() => {
  //             video.muted = false;
  //             video.play();
  //           }, 100);
  //         });
  //         mediaStates.set(media, true);
  //       } else if (!isInViewport && wasInViewport) {
  //         video.pause();
  //         mediaStates.set(media, false);
  //       }
  //     });
  //   });
  // }

  // gallery
  const gallerySections = document.querySelectorAll("section.gellary_section");

  gallerySections.forEach((section) => {
    const tags = section.querySelectorAll(".tags .tag");
    tags.forEach((tag) => {
      tag.addEventListener("click", (event) => {
        tags.forEach((elm) => elm.classList.remove("active"));
        tag.classList.add("active");

        let indexString = tag.getAttribute("index");
        let indexNum = indexString - 1;
        let sliders = section.querySelectorAll(
          ".swiper-pagination .swiper-pagination-bullet"
        );
        sliders[indexNum].click();
      });
    });

    const selector = section.querySelector(".tag_selector");

    selector.addEventListener("change", (event) => {
      let indexNum = selector.value - 1;
      let sliders = section.querySelectorAll(
        ".swiper-pagination .swiper-pagination-bullet"
      );
      sliders[indexNum].click();
    });
  });

  var gellary_slider = new Swiper(".gellary_slider", {
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  // testimonia scroll
  const scrollerRows = document.querySelectorAll(
    ".testimonial_scroller_wrapper .scroller_row"
  );
  scrollerRows.forEach((row) => {
    const height = row.querySelector(".scroller_content").offsetHeight;

    row.style.height = height + "px";
  });

  const brandRows = document.querySelectorAll(
    ".brnad_scroller_section .brands_slider .scroller_row"
  );
  brandRows.forEach((row) => {
    const height = row.querySelector(".scroller_content").offsetHeight;

    row.style.height = height + "px";
  });

  // templates
  const template_slider = new Swiper(".template_slider", {
    loop: true,
    slidesPerView: 3.5,
    spaceBetween: 20,
    centeredSlides: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 6.5,
      },
    },
  });

  // product tabs
  loadTabs("tabBox");

  const atcButton = document.querySelector(".product-form__buttons .product-form__submit");
  const atcAlterbtn = document.querySelectorAll(".altrAtcBtn[altrAtcBtn]");
  
  atcAlterbtn?.forEach(btn=>{
    btn.addEventListener("click", function(e){
      e.preventDefault();
      atcButton?.click();
    })
  });
  
  // clear console
  // setTimeout(()=>{console.clear();}, 3000);
});

window.addEventListener("resize", (event) => {
  const scrollerRows = document.querySelectorAll(
    ".testimonial_scroller_wrapper .scroller_row"
  );

  scrollerRows.forEach((row) => {
    const height = row.querySelector(".scroller_content").offsetHeight;

    row.style.height = height + "px";
  });
});

function loadAccordion(id) {
  let accordion = document.querySelector(id);
  let accordionItems = accordion.querySelectorAll(".accordion_item");

  accordionItems.forEach((accordionItem) => {
    let btn = accordionItem.querySelector(".accordion_button");

    if (accordionItem.classList.contains("active")) {
      show(accordionItem);
    } else {
      hide(accordionItem);
    }

    btn.addEventListener("click", () => {
      collapsOthers(accordionItems, accordionItem);

      if (accordionItem.classList.contains("active")) {
        accordionItem.classList.remove("active");
        hide(accordionItem);
      } else {
        accordionItem.classList.add("active");
        show(accordionItem);
      }
    });
  });
}

function show(accordion) {
  accordion.querySelector(".accordion_content").style.height =
    accordion.querySelector(".accordion_content .content_wrapper")
      .offsetHeight + "px";
}

function hide(accordion) {
  accordion.querySelector(".accordion_content").style.height = 0 + "px";
}

function collapsOthers(accordionItems, crntItem) {
  accordionItems.forEach((accordionItem) => {
    if (accordionItem !== crntItem) {
      accordionItem.classList.remove("active");
      hide(accordionItem);
    }
  });
}

function loadTabs(id) {
  const tabBox = document.getElementById(id);
  if (tabBox) {
    const triggers = tabBox.querySelectorAll(".triggers .trigger");
    const triggerSelector = tabBox.querySelector(".trigger_selector");
    const contents = tabBox.querySelectorAll(".content_wrapper .content");

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        triggers.forEach((elm) => elm.classList.remove("active"));
        trigger.classList.add("active");

        let index = trigger.getAttribute("target");
        let selectedContent = document.querySelector(
          `.content_wrapper .content[index="${index}"]`
        );

        contents.forEach((elm) => elm.classList.remove("active"));
        selectedContent.classList.add("active");
      });
    });

    if(triggerSelector){
      triggerSelector.addEventListener("change", (event) => {
        let value = triggerSelector.value;
        let selectedContent = document.querySelector(
          `.content_wrapper .content[index="${value}"]`
        );
  
        contents.forEach((elm) => elm.classList.remove("active"));
        selectedContent.classList.add("active");
      }); 
    }
  }
}
